<template>
	<header id="app-header">
		<section class="header-left">
			<img src="../../assets/sign/brand-logo-mini.png" alt="Logo" width="20" height="25" />
			<p class="header-left-title">{{$t('falcon5')}}</p> <p class="sub-title" ref="subtitleRef">{{$t('falcon5_slogan')}}</p>
		</section>
		<el-menu v-if="showMenu" :default-active="routePath" class="app-header-menu" background-color="#ffffff"
			text-color="#86909C" :router="true" :ellipsis="false" mode="horizontal" active-text-color="#165DFF">
			<el-menu-item v-for="(item, index) in newRouterList" :key="index" :index="item.index" :disabled="item.disabled"
				@click="selectMenuLink($event, item)"> {{ item.title }} </el-menu-item>
		</el-menu>
		
		<section class="header-right">
			<a :href="$t('falcon5_url')" :title="$t('Go to Ltranslate.com')" target="_blank" rel="noopener noreferrer">
  				<el-icon color="#4E5969" size="20">
    				<House />
  				</el-icon>
			</a>
			<div class="header-right-notice">
				<span class="un-read-dot">
					<span class="un-read-dot-text"> {{ unReadNum > 999 ? '...' : unReadNum }} </span>
				</span>
				<el-dropdown popper-class="header-notice-dropdown" @visible-change="openNoticeDropDown">
					<el-icon color="#4E5969" size="20">
						<Bell />
					</el-icon>
					<template #dropdown>
						<section class="notice-dropdown" v-loading="noticeLoading" :element-loading-svg="loadingSvg('#165DFF')"
							element-loading-svg-view-box="0 0 1024 1024">
							<div class="notice-dropdown-tabs">
								<div class="notice-dropdown-tab" @click="noticeDropdownTabsActive = item.type"
									v-for="(item, index) in noticeDropdownTabs"
									:class="{ 'active': item.type === noticeDropdownTabsActive }" :key="index"> {{ item.name }} </div>
							</div>
							<p class="notice-dropdown-list" v-if="noticeDropdownTabsActive === 'promotion'">
								<router-link :to="'/notice/notices/' + item.id" class="notice-dropdown-item"
									:class="{ 'is-unread': !item.readCount }" v-for="(item, index) in noticeListInfo" :key="index">
									<span class="notice-dropdown-item-left" :title="item.title"> {{ item.title }} </span>
								</router-link>
							</p>
							<ul class="notice-dropdown-list" v-else>
								<li class="notice-dropdown-item" :class="{ 'is-unread': !item.is_read }"
									v-for="(item, index) in noticeListInfo" :key="index">
									<span class="notice-dropdown-item-left"> {{ item.title }} </span>
									<span class="notice-dropdown-item-right"> {{ convertTimestamp(item.timestamp) }} </span>
								</li>
							</ul>
							<div class="notice-dropdown-footer" v-if="noticeListInfo.length">
								<el-button class="notice-dropdown-footer-item" type="primary" link @click="handleAllRead"
									:disabled="noticeLoading || !getUnReadMessage.length"> {{$L('All read')}} </el-button>
								<router-link :to="veiwAllLink" class="notice-dropdown-footer-item"> {{$L('View All')}} <el-icon>
										<DArrowRight />
									</el-icon>
								</router-link>
							</div>
							<div class="not-data" v-else>
								<img src="../../assets/global/icon-not-notice.svg" width="109px">
								<span class="not-data_text">No data</span>
							</div>
						</section>
					</template>
				</el-dropdown>
			</div>
			<div class="header-right-user">
				<el-dropdown popper-class="header-info-dropdown">
					<div class="header-right-user-info">
						<img width="30" height="30" class="header-right-user-avatar" :src="avatarUrl" alt="User Avatar" />
						<span class="header-right-user-name"> {{ nickname }} </span>
					</div>
					<template #dropdown>
						<section class="info-dropdown">
							<div class="info-dropdown-header">
								<div class="info-dropdown-header-left">
									<img class="info-dropdown-avatar" width="56px" height="56px" :src="avatarUrl" alt="User Avatar" />
									<div class="info-dropdown-userdetail">
										<div class="info-dropdown-userdetail-top">
											<p class="info-dropdown-userdetail-name"> {{ nickname }} </p>
											<p class="info-dropdown-userdetail-level" :style="currentUserVIPInfo.levelNumStyle"> LV{{
												headerProfileData.level }} </p>
											<p class="info-dropdown-userdetail-vip" :style="{
												'background-image':
													'url(' + currentUserVIPInfo.vipTypePosition + ')',
											}"></p>
										</div>
										<p class="info-dropdown-userdetail-email"> {{ newUserInfo.username }} </p>
									</div>
								</div>
								<el-tooltip class="box-item" effect="dark" :content="$L('Quit')" placement="top">
									<img @click="handleLogout" class="info-dropdown-header-right"
										src="../../assets/global/logout-icon.svg" width="27px" height="21px" alt="Logout" />
								</el-tooltip>
							</div>
							<div class="info-dropdown-main" :style="{
								'background-image': `url(${currentUserVIPInfo.levelMainBg})`,
							}">
								<div class="info-dropdown-progress">
									<span class="info-dropdown-progress-text"> LV{{ headerProfileData.level }} </span>
									<!-- <el-progress
										:color="currentUserVIPInfo.progressBg"
										:show-text="false"
										:percentage="newUserInfo.vipProgress"
									/> -->
									<el-progress :color="currentUserVIPInfo.progressBg" :show-text="false" :percentage="20" />
									<span class="info-dropdown-progress-text"> LV{{ currentUserVIPInfo.lastLvNum }} </span>
								</div>
								<div class="info-dropdown-money">
									<span class="info-dropdown-money-icon" :style="{
										'background-position':
											currentUserVIPInfo.moneyIconPosition,
									}"></span>
									<p class="info-dropdown-money-text" :style="{ color: currentUserVIPInfo.balanceColor }">
										<span class="info-dropdown-moey-currency">{{$L('price_format_mark')}}</span> {{ profileData?.money || '0.00' }}
									</p>
									<el-button @click="rechargeHandel" class="info-dropdown-recharge-btn" :class="currentUserVIPInfo.rechargeBtnClass" type="info"
										round size="default"> {{$L('recharge')}} </el-button>
								</div>
							</div>
							<div class="info-dropdown-footer">
								<router-link to="/personal-center" class="info-dropdown-footer-item">
									<el-icon size="18px">
										<User />
									</el-icon>
									<span> {{$L('personal center')}}</span>
								</router-link>
								<div to="/" class="info-dropdown-footer-item">
									<el-icon size="18px">
										<Setting />
									</el-icon>
									<span>  <a :href="`${$routes('/setings/')}`">{{ $L('setings') }}</a> </span>
								</div>
							</div>
						</section>
					</template>
				</el-dropdown>
			</div>
			<el-dialog class="warning-dialog common-pop-up" v-model="dialogState" width="384" align-center
				@closed="handleDialogClose">
				<div class="icon-wrapper">
					<el-icon color="#FF7D00" :size="47">
						<WarningFilled />
					</el-icon>
				</div>
				<p class="dialog-info"> {{ $t("global.insufficientBalanceReminder") }} </p>
				<template #footer>
					<el-button class="footer-btn footer-btn-cancel" type="info" @click="handleDialogClose">cancel</el-button>
					<el-button class="footer-btn footer-btn-delete" type="danger" @click="toRecharge"> recharge </el-button>
				</template>
			</el-dialog>
		</section>
	</header>
</template>
<script setup>
import { ref,reactive,watch,toRefs,computed,onMounted,onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useSelector,getAssetsFile } from '@/utils/hooks'
import { handleMergData,loadingSvg,convertTimestamp,formateDate } from '@/utils/utils'
import commonApi from '@/api/common'
import { useStore } from 'vuex'
import config from '@/config'
import recharge from '@/api/recharge'

const store = useStore()
const router = useRouter()

/* 右侧用户信息 */
const userInfo = useSelector(state => state.user.userInfo)

const unReadNum = ref(0)

const defaultAvatar = getAssetsFile('personal-center','default-avatar.png')

const dialogState = ref(false)

/* 右侧信息列表Tab */
const noticeDropdownTabs = ref([{
	name: window.$L('Notification'),
	type: 'promotion'
}])
const noticeDropdownTabsActive = ref('promotion')

const noticeListInfo = ref([])

/* 路由 */
const routePath = ref('')

/* 菜单列表 */
const menuList = [
	// {
	// 	index: '/overview',
	// 	title: window.$L('Overview'),
	// },
	{
		index: '/website',
		title: window.$L('WebSite'),
	},
	{
		index: '/subscribe',
		title: window.$L('Billing'),
	},
]

/* 动态获取用户信息 */
const newUserInfo = computed(() => {
	const newInfoObj = {}
	return handleMergData(
		newInfoObj,
		userInfo.value,
		['userName','email'],
		() => {
			if (!newInfoObj['avatar']) {
				newInfoObj['avatar'] = defaultAvatar
			} else {
				newInfoObj['avatar'] = config.baseUrl + newInfoObj['avatar']
			}
		}
	)
})

const props = defineProps(['modelValue'])
const emit = defineEmits(['update:modelValue'])
const { modelValue } = toRefs(props)
const clickingFlag = ref(modelValue.value)

const noticeLoading = ref(false)

const showMenu = ref(false)

const getProfileData = async () => {
	await store.dispatch('personalCenter/fetchProfile').then(data => {
		if (data) {
			const { unconfirmed_site_info,unread_notice_count,need_pop } = data
			unReadNum.value = unread_notice_count

			if(need_pop === true){
				dialogState.value = true
			}

			if (!unconfirmed_site_info && (userInfo.value['site_status'] === 4 || userInfo.value['site_status'] === 5)) {

				store.commit('user/SET_USERINFO',{ ...userInfo.value,site_status: 2 })
			} else if (unconfirmed_site_info) {
				const { site_status } = unconfirmed_site_info
				store.commit('user/SET_USERINFO',{ ...userInfo.value,site_status: site_status })
			}
		}
	})
}

/* 监听路由 */
watch(
	() => router.currentRoute.value.path,
	(newPath,oldPath) => {
		clickingFlag.value = false
		emit('update:modelValue',clickingFlag.value)

		showMenu.value = newPath !== '/website/all-sites'

		getProfileData()

		routePath.value = newPath
	},
	{ immediate: true }
)

/* 动态匹配二级路由 */
const newRouterList = computed(() => {
	const levelOneRouter = routePath.value && routePath.value.split('/')

	return menuList.map(item => {
		return {
			index:
				levelOneRouter?.length > 0 &&
					item['index'].includes(levelOneRouter[1])
					? routePath.value
					: item['index'],
			title: item['title'],
			currentPath: item['index'],
			disabled: item.title === 'Overview' && (userInfo.value['site_status'] === 1 || userInfo.value['site_status'] === 4)
		}
	})
})


/* 请求消息列表数据 */
const resultNoticeData = async (newValue) => {
	noticeLoading.value = true
	/* 获取消息列表 */
	store.dispatch('user/getUserNoticeList',{ type: newValue }).then(res => {
		if (res.code === 1) {
			const { data } = res.data
			noticeListInfo.value = data
		}
	}).finally(() => {
		noticeLoading.value = false
	})
}

const veiwAllLink = ref('/')
/* 监听消息列表Tab切换 */
watch(() => noticeDropdownTabsActive.value,
	async (newValue,oldValue) => {

		await resultNoticeData(newValue)
		veiwAllLink.value = newValue === 'invitation' ? '/notice/invitations' : '/notice/notices'

	},
	{ immediate: true }
)
/* 打开消息列表下拉框时更新数据 */
const openNoticeDropDown = async (falg) => {

	falg && await resultNoticeData(noticeDropdownTabsActive.value)

}

/* 获取当前分类未读消息 */
const getUnReadMessage = computed(() => {

	return noticeListInfo.value.filter(item => !item.is_read) || []
})

/* 已读所有信息 */
const handleAllRead = async () => {

	noticeLoading.value = true

	const params = {
		type: noticeDropdownTabsActive.value,
		ids: getUnReadMessage.value?.map(item => item.id).join(',')
	}

	await commonApi
		.readAllMessage(params)
		.then(res => {
			if (res.code === 1)
				ElMessage({
					message: res.msg,
					type: 'success',
					plain: true,
				})
			resultNoticeData(noticeDropdownTabsActive.value)
		})
		.finally(() => {
			noticeLoading.value = false
		})
}

/* 退出登录 */
const handleLogout = () => {
	const loading = ElLoading.service({
		lock: true,
		text: 'Logging out...',
		background: 'rgba(0, 0, 0, 0.7)',
	})
	const params = { token: userInfo.value.token }
	store
		.dispatch('user/logoutAction',params)
		.then(res => {
			ElMessage.success({ message: res.msg,center: true })
			router.push('/sign-in')
		})
		.finally(() => {
			loading.close()
		})
}

/* 菜单点击事件 */
const selectMenuLink = (exampleItem,item) => {
	if (router.currentRoute.value.path !== item.currentPath)
		router.push(item.currentPath)

	emit('update:modelValue',clickingFlag.value)
}

/* 请求个人资料 */
const headerProfileData = ref({})
const { profileData } = toRefs(store.state.personalCenter)
headerProfileData.value = profileData.value

watch(profileData,(newValue,oldValue) => {
	headerProfileData.value = newValue
})



const nickname = computed(() => {
	const name = headerProfileData.value?.nickname
	const match = name?.match(/^([^@]+)/)
	const result = match ? match[1] : ''
	return result
})

const avatarUrl = computed(() => {
	if (
		profileData.value?.avatar?.includes('data:image') ||
		!profileData.value?.avatar
	) {
		return defaultAvatar
	} else {
		return config.baseUrl + profileData.value.avatar
	}
})

/* vip信息相关列表 */
const vipLevelList = reactive({
	['1,2,3']: {
		levelNumStyle: {
			backgroundColor: '#F7F8FA',
			color: '#D3D3D3',
			border: '.3px solid #D3D3D3',
		},
		levelMainBg: getAssetsFile('global','lv1-3-bg.png'),
		progressBg: 'linear-gradient(90deg, #4E4E4E 0%, #848484 100%)',
		rechargeBtnClass: 'regular',
		moneyIconPosition: ' -178px -9px',
		balanceColor: '#424242',
		vipTypePosition: getAssetsFile('personal-center','icon-rvip.svg'),
	},
	['4,5,6']: {
		levelNumStyle: {
			backgroundColor: '#F8FAFF',
			color: '#4E5969',
			border: '.3px solid #D3E3FF',
		},
		levelMainBg: getAssetsFile('global','lv4-6-bg.png'),
		progressBg: 'linear-gradient(90deg, #1450D6 0%, #35AAFF 100%)',
		rechargeBtnClass: 'premium',
		moneyIconPosition: '-152px -9px',
		balanceColor: '#165DFF',
		vipTypePosition: getAssetsFile('personal-center','icon-pvip.svg'),
	},
	['7,8,9']: {
		levelNumStyle: {
			backgroundColor: '#FFFDF9',
			color: '#7E6123',
			border: '.3px solid #F8DDAB',
		},
		levelMainBg: getAssetsFile('global','lv7-9-bg.png'),
		progressBg: 'linear-gradient(90deg, #FF8A1F 0%, #FFAE50 100%)',
		rechargeBtnClass: 'supreme',
		moneyIconPosition: '-126px -9px',
		balanceColor: '#F66C00',
		vipTypePosition: getAssetsFile('personal-center','icon-svip.svg'),
	},
})

const currentUserVIPInfo = computed(() => {
	const obj = {}

	for (const key in vipLevelList) {
		if (~key.indexOf(headerProfileData.value?.level)) {
			obj.levelNumStyle = vipLevelList[key].levelNumStyle || null
			obj.levelMainBg = vipLevelList[key].levelMainBg || null
			obj.progressBg = vipLevelList[key].progressBg || null
			obj.lastLvNum = key.split(',')[key.split(',').length - 1]
			obj.rechargeBtnClass = vipLevelList[key].rechargeBtnClass || null
			obj.moneyIconPosition = vipLevelList[key].moneyIconPosition || null
			obj.balanceColor = vipLevelList[key].balanceColor || null
			obj.vipTypePosition = vipLevelList[key].vipTypePosition || null
		}
	}

	return obj
})

/* 关闭警告弹框 */
const handleDialogClose = () => {
	dialogState.value = false
}
/* 跳转到充值页 */
const toRecharge = ()=> {
	router.push('/subscribe/recharge-center')
	handleDialogClose()
}

/* vip信息相关列表 */
	// const vipLevelList = reactive({
	// ['1,2,3']: {
	// 	levelNumStyle: {
	// 		backgroundColor: '#F7F8FA',
	// 		color: '#D3D3D3',
	// 		border: '.3px solid #D3D3D3',
	// 	},
	// 	levelMainBg: getAssetsFile('global', 'lv1-3-bg.png'),
	// 	progressBg: 'linear-gradient(90deg, #4E4E4E 0%, #848484 100%)',
	// 	rechargeBtnClass: 'regular',
	// 	moneyIconPosition: ' -178px -9px',
	// 	balanceColor: '#424242',
	// },
	// ['4,5,6']: {
	// 	levelNumStyle: {
	// 		backgroundColor: '#F8FAFF',
	// 		color: '#4E5969',
	// 		border: '.3px solid #D3E3FF',
	// 	},
	// 	levelMainBg: getAssetsFile('global', 'lv4-6-bg.png'),
	// 	progressBg: 'linear-gradient(90deg, #1450D6 0%, #35AAFF 100%)',
	// 	rechargeBtnClass: 'premium',
	// 	moneyIconPosition: '-152px -9px',
	// 	balanceColor: '#165DFF',
	// },
	// ['7,8,9']: {
	// 	levelNumStyle: {
	// 		backgroundColor: '#FFFDF9',
	// 		color: '#7E6123',
	// 		border: '.3px solid #F8DDAB',
	// 	},
	// 	levelMainBg: getAssetsFile('global', 'lv7-9-bg.png'),
	// 	progressBg: 'linear-gradient(90deg, #FF8A1F 0%, #FFAE50 100%)',
	// 	rechargeBtnClass: 'supreme',
	// 	moneyIconPosition: '-126px -9px',
	// 	balanceColor: '#F66C00',
	// },
	// vipTypePosition: {
	// 	1: getAssetsFile('personal-center', 'icon-rvip.svg'),
	// 	2: getAssetsFile('personal-center', 'icon-pvip.svg'),
	// 	3: getAssetsFile('personal-center', 'icon-svip.svg'),
	// },
	// })

/* 当前用户vip信息 */
	// const currentUserVIPInfo = reactive({
	// 	levelNumStyle: '',
	// 	levelMainBg: '',
	// 	vipTypePosition: '',
	// 	progressBg: '',
	// 	lastLvNum: 0,
	// 	rechargeBtnClass: '',
	// 	moneyIconPosition: '',
	// 	balanceColor: '',
	// })

/* vip部分动态样式 */
	// const getUserVipStyle = () => {
	// 	for (const key in vipLevelList) {
	// 		if (~key.indexOf(userInfo?.value?.level)) {
	// 			currentUserVIPInfo.levelNumStyle =
	// 				vipLevelList[key].levelNumStyle || null
	// 			currentUserVIPInfo.levelMainBg = vipLevelList[key].levelMainBg || null
	// 			currentUserVIPInfo.progressBg = vipLevelList[key].progressBg || null
	// 			currentUserVIPInfo.lastLvNum = key.split(',')[key.split(',').length - 1]
	// 			currentUserVIPInfo.rechargeBtnClass =
	// 				vipLevelList[key].rechargeBtnClass || null
	// 			currentUserVIPInfo.moneyIconPosition =
	// 				vipLevelList[key].moneyIconPosition || null
	// 			currentUserVIPInfo.balanceColor = vipLevelList[key].balanceColor || null
	// 		}
	// 	}
	// 	currentUserVIPInfo.vipTypePosition =
	// 		vipLevelList.vipTypePosition[userInfo?.value?.vipType] || null
	// }

	// getUserVipStyle()
	const rechargeHandel=async()=>{
		router.push('/subscribe/recharge-center')
	}

// 每 5 秒触发一次副标题动画
const subtitleRef = ref(null)
let subtitleTimer = null
const triggerSubtitle = () => {
	const el = subtitleRef.value
	if (!el) return
	el.classList.remove('subtitle-pulse')
	void el.offsetWidth
	el.classList.add('subtitle-pulse')
}
onMounted(() => {
	// 首次立即触发一次
	triggerSubtitle()
	// 每 5 秒无限循环触发
	subtitleTimer = setInterval(() => {
		triggerSubtitle()
	}, 5000)
})
onUnmounted(() => {
	if (subtitleTimer) {
		clearInterval(subtitleTimer)
		subtitleTimer = null
	}
})
</script>
<style lang="less">
.header-notice-dropdown.el-popper.el-dropdown__popper {
	.el-popper__arrow {
		&::before {
			background-color: #F9F9F9 !important;
		}
	}
}
</style>
<style lang="less" scoped>
#app-header {
	position: sticky;
	top: 0;
	z-index: 999;
	width: 100%;
	height: 60px;
	border-bottom: 1px solid #dae6ff;
	background: #fff;
	padding: 0 80px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.header-left {
	display: flex;
	align-items: center;
	gap: 4px;

	&-title {
		color: #1d2129;
		font-size: 18px;
		line-height: 1;
	}

	.sub-title {
		margin-left: 8px;
		color: #6b7280;
		font-size: 13px;
		line-height: 1;
		letter-spacing: 0.2px;
		font-weight: 400;
		opacity: 0.9;

		will-change: opacity, transform, clip-path;
		animation: none;

		&.subtitle-pulse { animation: subtitleFadeIn 900ms cubic-bezier(0.22, 1, 0.36, 1) both; }
	}

	@keyframes subtitleReveal {
		0% {
			opacity: 0;
			transform: translateY(-1px);
	
		}
		100% {
			opacity: 0.9;
			transform: translateY(0);
			clip-path: inset(0 0 0 0);
		}
	}
}

@keyframes subtitleFadeIn {
	0% {
		opacity: 0.2;
		clip-path: inset(0 100% 0 0);
	}
	60% {
		opacity: 0.85;
		clip-path: inset(0 20% 0 0);
	}
	100% {
		opacity: 1;
		clip-path: inset(0 0 0 0);
	}
}

.el-menu--horizontal {
	border-bottom: unset !important;
	height: 100%;
	justify-content: center;
	gap: 50px;

	:deep(.el-menu-item) {
		border-bottom: unset;
		font-size: 20px;
		font-weight: 400;
		color: #c9cdd4;

		&.is-active {
			position: relative;
			border-bottom: unset;

			&::after {
				content: '';
				display: inline-block;
				height: 5px;
				width: 100%;
				position: absolute;
				left: 0;
				bottom: 0;
				background-color: var(--el-menu-active-color);
				border-radius: 6px 6px 0px 0px;
			}
		}

		&:not(.is-disabled):hover,
		&:not(.is-disabled):focus {
			background-color: unset;
		}
	}
}

.header-right {
	display: flex;
	align-items: center;
	gap: 20px;

	&-user {
		flex: 0 0 20%;
	}

	&-user-info {
		display: inline-flex;
		align-items: center;
		gap: 10px;
	}

	&-user-avatar {
		border-radius: 38px;
	}

	&-user-name {
		color: #4e5969;
		font-size: 14px;
		line-height: 22px;
		white-space: nowrap;
	}
}

.header-right-notice {
	position: relative;
	cursor: pointer;

	.un-read-dot {
		position: absolute;
		border: 1px solid #fff;
		border-radius: 16px;
		width: 16px;
		height: 16px;
		right: -6px;
		top: -6px;
		background-color: red;
		z-index: 2;
		display: inline-flex;
		justify-content: center;
		align-items: center;

		&-text {
			color: #fff;
			font-size: 10px;
			font-weight: 700;
			white-space: nowrap;
			transform: scale(0.7);
		}
	}

	:deep(.el-icon) {
		outline: none;
	}
}

.header-right-user {
	cursor: pointer;

	.header-right-user-info {
		outline: none;
	}
}

.notice-dropdown {
	&-tabs {
		padding: 10px 20px;
		border-radius: 4px 4px 0px 0px;
		background: #F9F9F9;
		display: flex;
		gap: 30px;
	}

	&-tab {
		font-size: 14px;
		color: #1D2129;
		cursor: pointer;

		&:hover {
			color: #165DFF;
		}

		&.active {
			position: relative;
			color: #165DFF;

			&:after {
				content: '';
				width: 100%;
				position: absolute;
				height: 3px;
				background-color: #165DFF;
				bottom: -10px;
				left: 0;
			}
		}
	}

	&-list {
		padding: 10px 20px;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 12px;
	}

	&-item {
		list-style: none;
		position: relative;
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: -webkit-fill-available;

		&:before {
			content: '';
			position: absolute;
			left: -10px;
			top: 50%;
			transform: translateY(-50%);
			display: none;
			width: 5px;
			height: 5px;
			border-radius: 5px;
			background-color: #f53f3f;
		}

		&.is-unread {
			&:before {
				display: inline-block;
			}
		}

		&:first-child {
			.notice-dropdown-item-left {
				color: #4e5969;
			}

			.notice-dropdown-item-right {
				color: #4e5969;
			}
		}
	}

	&-item-left {
		color: #86909c;
		font-size: 12px;
		.txt-ellipsis();
		width: 290px;
		display: inline-block;
	}

	&-item-right {
		color: #c9cdd4;
		font-size: 12px;
	}

	&-footer {
		padding: 10px 22px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-top: 1px solid #efefef;
	}

	&-footer-item {
		color: #6aa1ff;
		font-size: 12px;
		cursor: pointer;
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.not-data {
		text-align: center;
		margin: 10px auto 45px;
		display: flex;
		flex-direction: column;
		align-items: center;

		&_text {
			color: #BFBFBF;
			font-size: 16px;
		}
	}
}

.info-dropdown {
	padding: 22px;

	&-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	&-header-left {
		display: flex;
		align-items: center;
		gap: 11px;
	}

	&-avatar {
		border-radius: 56px;
	}

	&-userdetail {
		display: flex;
		flex-direction: column;
	}

	&-userdetail-top {
		display: flex;
		align-items: center;
		gap: 2px;
	}

	&-userdetail-name {
		color: #4e5969;
		font-size: 20px;
		font-weight: 400;
		line-height: 28px;
		max-width: 90px;
		.txt-ellipsis();
	}

	&-userdetail-level {
		display: inline-flex;
		padding: 0.5px 10px;
		justify-content: center;
		align-items: center;
		border-radius: 25px;
		font-size: 10px;
		font-weight: 400;
		transform: scale(0.8);
	}

	&-userdetail-vip {
		background-repeat: no-repeat;
		background-size: 100% 100%;
		width: 35px;
		height: 14px;
		transform: scale(1.35) translate(5px, 0);
	}

	&-userdetail-email {
		color: #86909c;
		font-size: 12px;
		font-style: normal;
		font-weight: 400;
		line-height: 20px;
	}

	&-header-right {
		filter: grayscale(1);
		cursor: pointer;

		&:hover {
			filter: unset;
		}
	}

	&-main {
		margin-top: 20px;
		background-size: 100% 100%;
		background-repeat: no-repeat;
		padding: 12px 12px 17px;
		width: 100%;
	}

	&-progress {
		display: flex;
		align-items: center;
		gap: 10px;

		.el-progress {
			width: 100%;

			&:deep(.el-progress-bar__outer) {
				background-color: #fff;
			}
		}
	}

	&-progress-text {
		color: #2e3948;
		font-size: 12px;
		font-weight: 400;
		line-height: 20px;
	}

	&-money {
		margin-top: 13px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	&-money-icon {
		display: inline-block;
		background-image: url('../../assets/global/vip-sprite.png');
		background-repeat: no-repeat;
		width: 22px;
		height: 21px;
	}

	&-money-currency {
		margin-left: 8px;
		display: inline-block;
	}

	&-money-text {
		font-size: 22px;
		font-weight: 900;
		flex-grow: 1;
		text-align: left;
		margin-left: 8px;
	}

	&-recharge-btn {
		border: unset;

		&:hover {
			border: unset;
		}

		&.regular {
			background: linear-gradient(270deg, #424242 0, #888 100%);

			&:hover {
				box-shadow: 0 0 8px 0 #acb4c1;
			}

			&:active {
				background: linear-gradient(270deg, #252525 0%, #727272 100%);
			}
		}

		&.premium {
			background: linear-gradient(270deg, #165dff 0%, #6191ff 100%);

			&:hover {
				box-shadow: 0 0 8px 0 #7fa4dc;
			}

			&:active {
				background: linear-gradient(0deg,
						rgba(0, 0, 0, 0.1) 0%,
						rgba(0, 0, 0, 0.1) 100%),
					linear-gradient(270deg, #165dff 0%, #6191ff 100%);
			}
		}

		&.supreme {
			background: linear-gradient(270deg, #ff8311 0%, #ffb71e 100%);

			&:hover {
				box-shadow: 0 0 8px 0 #ffc368;
			}

			&:active {
				background: linear-gradient(0deg,
						rgba(0, 0, 0, 0.1) 0%,
						rgba(0, 0, 0, 0.1) 100%),
					linear-gradient(270deg, #ff8311 0%, #ffb71e 100%);
			}
		}
	}

	&-footer {
		display: flex;
		margin-top: 18px;
	}

	&-footer-item {
		display: flex;
		padding: 10px 12px;
		flex: 0 0 50%;
		gap: 6px;
		align-items: center;
		justify-content: center;
		color: #86909c;
		font-size: 12px;
		border-radius: 6px;
		box-sizing: border-box;

		&:hover {
			background: #f3f7fb;
			color: #165dff;
		}
	}
}
</style>
